var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaQrcode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 400,
    viewBox: "0 0 400 400",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.5 62.5V162.5H87.5V187.5H112.5V162.5H162.5V62.5H62.5ZM162.5 162.5V187.5H187.5V212.5H137.5V237.5H62.5V337.5H162.5V237.5H237.5V212.5H212.5V187.5H262.5V162.5H287.5V187.5H312.5V162.5H337.5V62.5H237.5V162.5H162.5ZM312.5 187.5V212.5H337.5V187.5H312.5ZM312.5 212.5H287.5V237.5H312.5V212.5ZM312.5 237.5V262.5H337.5V237.5H312.5ZM312.5 262.5H287.5V237.5H262.5V262.5H200V337.5H225V287.5H275V312.5H300V287.5H312.5V262.5ZM275 312.5H250V337.5H275V312.5ZM287.5 212.5V187.5H262.5V212.5H287.5ZM137.5 212.5V187.5H112.5V212.5H137.5ZM87.5 187.5H62.5V212.5H87.5V187.5ZM187.5 62.5V112.5H175V137.5H187.5V150H212.5V112.5H225V87.5H212.5V62.5H187.5ZM87.5 87.5H137.5V137.5H87.5V87.5ZM262.5 87.5H312.5V137.5H262.5V87.5ZM100 100V125H125V100H100ZM275 100V125H300V100H275ZM87.5 262.5H137.5V312.5H87.5V262.5ZM100 275V300H125V275H100ZM312.5 312.5V337.5H337.5V312.5H312.5Z",
    fill: "#191919"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaQrcode);
export default __webpack_public_path__ + "static/media/la_qrcode.d2e01d6f50047d56d1164e735e601686.svg";
export { ForwardRef as ReactComponent };